import { render, staticRenderFns } from "./CreateContract.vue?vue&type=template&id=8f31fab2&"
import script from "./CreateContract.vue?vue&type=script&lang=js&"
export * from "./CreateContract.vue?vue&type=script&lang=js&"
import style0 from "./CreateContract.vue?vue&type=style&index=0&id=8f31fab2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports